export default "development";


// WEBPACK FOOTER //
// ./src/config/env.js